import { render, staticRenderFns } from "./TruckAdd.vue?vue&type=template&id=7b6c61ec&scoped=true"
import script from "./TruckAdd.vue?vue&type=script&lang=js"
export * from "./TruckAdd.vue?vue&type=script&lang=js"
import style0 from "./TruckAdd.vue?vue&type=style&index=0&id=7b6c61ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c61ec",
  null
  
)

export default component.exports